type Props = {
  onClick?: () => void
}

export const ImageSearchTutorial: React.FC<Props> = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="
        relative inline-block whitespace-nowrap rounded-[9px] bg-green-450 px-[15px] py-[9px] text-center text-[11px] leading-normal text-white shadow-icon
        before:absolute before:left-1/2 before:top-[99%] before:-translate-x-1/2 before:border-8 before:border-transparent before:border-t-green-450 before:content-['']"
      aria-hidden
    >
      この画像から
      <br />
      似たアイテムを
      <br />
      検索できます
    </div>
  )
}
